import { render, staticRenderFns } from "./UsersDetail.vue?vue&type=template&id=03a1bb7a&"
import script from "./UsersDetail.vue?vue&type=script&lang=js&"
export * from "./UsersDetail.vue?vue&type=script&lang=js&"
import style0 from "./UsersDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports